import * as React from 'react';
import Stack from '@mui/material/Stack';
import TrapFocus from '@mui/material/Unstable_TrapFocus';
import CssBaseline from '@mui/material/CssBaseline';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Container from '@mui/material/Container';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Paper from '@mui/material/Paper';
import Fade from '@mui/material/Fade';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/Stack": Stack, "@mui/material/Unstable_TrapFocus": TrapFocus, "@mui/material/CssBaseline": CssBaseline, "@mui/material/AppBar": AppBar, "@mui/material/Toolbar": Toolbar, "@mui/material/Container": Container, "@mui/material/IconButton": IconButton, "@mui/icons-material/Menu": MenuIcon, "@mui/material/Paper": Paper, "@mui/material/Fade": Fade, "@mui/material/Button": Button, "@mui/material/Box": Box, "@mui/material/Typography": Typography } } });
export default ClientProvider;
